import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Avatar } from "primereact/avatar";
import { useEffect, useRef, useState } from "react";
import { IContact } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./Contact";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { GenLead } from "./GenLead";
import { BulkUploadForm } from "./BulkUpload";
import { Toolbar } from "primereact/toolbar";
import { CallHistory } from "./CallHistory";
import { MassMailing } from "./MassMailing";
import { WhatsppSendTemplate } from "./WhatsappTemplate";
import { Dialog } from "primereact/dialog";
import { Filter, IFilter } from "./Filter";
import { Tooltip } from "primereact/tooltip";
import { showDateTime } from "../../utilities/helper";


interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IContact[], count: number, loading: boolean });
    const [selectedContacts, setSelectedContacts] = useState<IContact[]>([]);
    const [text, setText] = useState<string | null>(null);
    const [openleadBulkUpload, setOpenleadBulkUpload] = useState({ singleData: {}, open: false } as IOpenForm);
    const [openCallDailor, setOpenCallDailor] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean })
    const [openCallHistory, setOpenCallHistory] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean })
    const [openSendEmail, setOpenSendEmail] = useState(false);
    const [openWhatsappMsg, setOpenWhatsappMsg] = useState({ singleData: {}, open: false } as IOpenForm);
    const [filter, setFilter] = useState<IFilter>({});
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    const [genLead, setGenLead] = useState(false);
    const hideGenLeadDialog = () => {
        setGenLead(false)
    };

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, filter, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(
            "contact",
            "GET",
            null,
            `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(filter)}${text ? "&text=" + text : ""}`,
            props.toast
        );
        if (response) {
            const data: { contacts: IContact[], count: number } = await response.json();
            setTableData({ data: data.contacts, count: data.count, loading: false });
            setSelectedContacts([]);
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const generateLead = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const data = { contactIds: selectedContacts.map(c => c.id) };
        const response = await Fetch("contact/generatelead", "POST", data, null, props.toast);
        if (response) {
            setSelectedContacts([]);
            props.toast.current.show({ severity: 'success', detail: "Leads generated successfully", life: 3000 });
        }
        setTableData((prev) => ({ ...prev, loading: false, }));
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: {} });
    };

    const openEdit = (rowData: IContact) => {
        props.setModal({ open: true, singleData: { ...rowData } });
    };

    const Remove = async (rowData: IContact) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`contact/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Contact Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IContact) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.name}(${rowData.phoneNumber})"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }



    const addressBody = (rowData: IContact) => {
        return (
            rowData.cityName ?
                <span>{rowData.cityName}, {rowData.stateName}, {rowData.countryName}</span> :
                rowData.stateName ?
                    <span>{rowData.stateName}, {rowData.countryName}</span> :
                    <span>{rowData.countryName}</span>
        );
    }

    const actionBodyTemplate = (rowData: IContact) => (
        <div className="flex gap-2 justify-content-center">
            {props.hasPermission("Contact", "Edit") && (
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-sm" onClick={() => openEdit(rowData)} />
            )}
            {props.hasPermission("Contact", "Remove") && (
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-sm" onClick={() => confirmDelete(rowData)} />
            )}
            {/* <Button icon="pi pi-phone" className="p-button-rounded p-button-info p-button-sm" onClick={() => { setOpenCallDailor({ open: true, singleData: rowData }); callOnNumber(rowData); }} /> */}
            <Button
                icon="pi pi-phone"
                className="p-button-rounded p-button-info p-button-sm"
                onClick={() => callOnNumber(rowData)}
            />

            <Button icon="pi pi-history" className="p-button-rounded p-button-secondary p-button-sm" onClick={() => setOpenCallHistory({ open: true, singleData: rowData })} />
        </div>
    );


    const remarkBody = (rowData: any) => {
        const remark = rowData.remark || "";

        if (remark.length <= 29) {
            return <span>{remark}</span>;
        }

        return (
            <>
                <Tooltip target={`.remark-${rowData.id}`} />
                <span
                    className={`remark-${rowData.id}`}
                    data-pr-tooltip={remark}
                    style={{
                        cursor: "pointer",
                        display: "inline-block"
                    }}
                >
                    {remark.substring(0, 29)}...
                </span>
            </>
        );
    };

    const rightToolbarTemplate = () => {
        const handleDownload = () => {
            const link = document.createElement("a");
            link.href = "/ContactSample.xlsx";
            link.download = "ContactSample.xlsx";
            link.click();
        };

        return (
            <div className="flex gap-2">
                {/* Bulk Upload */}
                <Button
                    label="Bulk Upload"
                    icon="pi pi-upload"
                    className="p-button-success p-button-rounded p-button-sm"
                    tooltip="Upload multiple contacts"
                    onClick={() => setOpenleadBulkUpload({ singleData: {}, open: true })}
                />

                {/* Download Sample */}
                <Button
                    label="Download"
                    icon="pi pi-download"
                    className="p-button-outlined p-button-info p-button-rounded p-button-sm"
                    tooltip="Download sample Excel template"
                    onClick={handleDownload}
                />

                {/* Send Email */}
                <Button
                    label="Send Email"
                    icon="pi pi-envelope"
                    className="p-button-warning p-button-rounded p-button-sm"
                    tooltip="Send email to selected contacts"
                    onClick={() => {
                        if (selectedContacts?.length > 0) {
                            setOpenSendEmail(true);
                        } else {
                            props.toast.current.show({
                                severity: 'warn',
                                detail: 'Please select at least 1 contact to send email.',
                                life: 3000,
                            });
                        }
                    }}
                />

                {/* Send WhatsApp */}
                <Button
                    label="Send WhatsApp"
                    icon="pi pi-whatsapp"
                    className="p-button-rounded p-button-sm text-white"
                    style={{ backgroundColor: "#25D366", borderColor: "#25D366" }}
                    tooltip="Send WhatsApp message to selected contacts"
                    tooltipOptions={{ position: 'left' }}
                    onClick={() => {
                        if (selectedContacts?.length > 0) {
                            setOpenWhatsappMsg({ singleData: {}, open: true });
                        } else {
                            props.toast.current.show({
                                severity: 'warn',
                                detail: 'Please select at least 1 contact to send WhatsApp.',
                                life: 3000,
                            });
                        }
                    }}
                />
            </div>
        );
    };

    // const callOnNumber = async (body?: any) => {
    //     body = {
    //         customerNumber: body.phoneNumber,
    //         contactId: body.id
    //     }
    //     const response = await Fetch("IVR/click-to-call", "POST", body, null, props.toast);
    //     if (response) {
    //         props.toast.current.show({ severity: 'success', detail: "Calling Successfully", life: 3000 });

    //     }

    // };

    // const callOnNumber = async (rowData: any) => {
    //     try {
    //         setOpenCallDailor({ open: true, singleData: rowData });
    //         const response = await Fetch("Kommuno/sso-login", "GET", null, null, props.toast);
    //         //const data = await response.json(); 
    //         if (response) {
    //             const data: { urls: string } = await response.json();

    //             console.log(data)
    //             window.open(data.urls, "_blank");
    //             props.toast.current.show({ severity: "success", detail: "Dialer opened successfully", life: 3000 });
    //         } else {
    //             props.toast.current.show({ severity: "error", detail: "Dialer URL not received", life: 3000 });
    //         }
    //     } catch (err) {
    //         props.toast.current.show({ severity: "error", detail: "Failed to open dialer", life: 3000 });
    //     }
    // };

    const callOnNumber = async (rowData: any) => {
        try {
            console.log(rowData)
            setOpenCallDailor({ open: true, singleData: rowData });
            const mapBody = {
                contactId: rowData.id
            };
            const callBody = {
                customerNumber: rowData.phoneNumber,
                contactId: rowData.id
            }
            // await Fetch("Kommuno/map-contact", "POST", mapBody, null, props.toast);
            await Fetch("IVR/click-to-call", "POST", callBody, null, props.toast);

            //  const response = await Fetch("Kommuno/sso-login", "GET", null, null, props.toast);

            // if (response) {
            //     const data = await response.json();
            //     window.open(data.urls, "_blank");

            //     props.toast.current.show({ severity: "success", detail: "Dialer opened successfully", life: 3000 });
            // }
        } catch (err) {
            props.toast.current.show({ severity: "error", detail: "Failed to open dialer", life: 3000 });
        }
    };

    const onHide = () => {
        setOpenSendEmail(false);
        setOpenCallDailor({ open: false, singleData: {} });
    }
    const nameTemplate = (rowData: any) => (
        <div className="flex items-center gap-2">
            <Avatar label={rowData.name?.[0]} shape="circle" className="bg-green-500 text-white" />
            <span>{rowData.name}</span>
        </div>
    );


    const leadStatusBody = (rowData: any) => {
        return rowData.leadAlreadyGenerated ? (
            <i
                className="pi pi-check-circle"
                style={{ color: "green", fontSize: "1.2rem" }}
            />
        ) : (
            <i
                className="pi pi-times-circle"
                style={{ color: "red", fontSize: "1.2rem" }}
            />
        );
    };







    return (
        <>
            <Toolbar className="mb-3 px-3 py-2 border-round-lg shadow-sm"
                left={() => (
                    <div className="flex gap-2">
                        {props.hasPermission("Contact", "Add") && (
                            <Button label="New" icon="pi pi-plus" className="p-button-success p-button-rounded" onClick={openNew} />
                        )}
                    </div>
                )}
                right={rightToolbarTemplate}
            />
            <Filter toast={props.toast} header={"Filter"} loading={tableData.loading} hasPermission={props.hasPermission} filter={filter} setFilter={setFilter} />
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="67vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={
                    <div className="flex justify-content-between align-items-center px-2">
                        <h3 className="m-0 text-uppercase font-bold tracking-wide">Contact</h3>
                        <div className="flex gap-3">
                            {selectedContacts.length > 0 && (
                                <Button label="Generate Lead" icon="pi pi-plus" className="p-button-sm p-button-success p-button-rounded" onClick={() => setGenLead(true)} />
                            )}
                            <div className="p-input-icon-left">
                                <Search setSearch={setText} />
                            </div>
                            {props.hasPermission("Contact", "Export") && (
                                <Button label="Export" icon="pi pi-upload" className="p-button-help p-button-rounded p-button-sm" onClick={exportCSV} />
                            )}
                        </div>
                    </div>
                }
                loading={tableData.loading}
                selectionMode="checkbox" selection={selectedContacts} onSelectionChange={(e) => setSelectedContacts(e.value)}
            >
                <Column selectionMode="multiple"></Column>
                <Column header="Lead Generated" body={leadStatusBody} />
                <Column field="name" header="Name" sortable body={nameTemplate} />
                <Column field="phoneNumber" header="Contact" sortable />
                <Column field="alternativePhone" header="A.Contact" />
                <Column field="whatsapp" header="Whatsapp" sortable />
                <Column field="email" header="Email" sortable />
                <Column field="alternativeEmail" header="A.Email" />
                <Column field="address" header="Address" body={addressBody} />

                <Column
                    field="remark"
                    header="Remark"
                    body={remarkBody}
                />
                <Column field="createdBy" header="CreatedBy" />
                <Column field="createdAt" header="Created At" sortable
                    body={(row) =>
                        row.createdAt
                            ? showDateTime(row.createdAt)
                            : "-"
                    }
                />
                <Column field="updatedBy" header="UpdateBy" />
                <Column field="updatedAt" header="UpdatedAt" sortable body={(row) =>
                    row.updatedAt
                        ? showDateTime(row.updatedAt)
                        : "-"
                } />
                {/* <Column field="lastWpMessage" header="Last Whatsapp" body={(row) =>
                    row.lastWpMessage
                        ? `${showDateTime(row.lastWpMessage.sendAt)}(${row.lastWpMessage.wpTemplateName})`
                        : "-"
                } /> */}
                {/* <Column field="uploadedDate" header="UploadedDate" sortable body={(row) =>
                        row.uploadedDate
                            ? showDateTime(row.uploadedDate)
                            : "-"
                    }/> */}

                <Column body={actionBodyTemplate} header="Actions" style={{ textAlign: "center", width: "10rem" }} />
            </DataTable>
            <ConfirmDialog />
            <GenLead open={genLead} hideDialog={hideGenLeadDialog} reloadData={loadTableData} contacts={selectedContacts} toast={props.toast} />
            <BulkUploadForm hasPermission={props.hasPermission} singleData={openleadBulkUpload.singleData} open={openleadBulkUpload.open} hideDialog={() => setOpenleadBulkUpload({ singleData: {}, open: false })}
                toast={props.toast}
                reloadData={props.reloadData}
            />
            <CallHistory hasPermission={props.hasPermission} singleData={openCallHistory.singleData} open={openCallHistory.open} hideDialog={() => setOpenCallHistory({ singleData: {}, open: false })}
                toast={props.toast}
                reloadData={props.reloadData}
            />
            <MassMailing tableData={selectedContacts || []} openSendEmail={openSendEmail} closeSendEmailModal={onHide} toast={props.toast} />
            <WhatsppSendTemplate hasPermission={props.hasPermission} contacts={selectedContacts || []} open={openWhatsappMsg.open} hideDialog={() => setOpenWhatsappMsg({ singleData: {}, open: false })}
                toast={props.toast}
                reloadData={props.reloadData} />
            <Dialog visible={openCallDailor.open} style={{ width: '600px' }} header="" modal className="p-fluid" onHide={onHide}>
                <h1>Calling ...</h1>
            </Dialog>

        </>
    );
}
